export function haversine(a, b) {
  if (!a || !b) return null;
  const R = 6371000; // meters
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

export function fmtDistance(m) {
  if (m == null) return "—";
  if (m < 1000) return `${Math.round(m)} m`;
  return `${(m / 1000).toFixed(m < 10000 ? 2 : 1)} km`;
}

export function fmtWalk(m) {
  if (m == null) return null;
  const mins = Math.max(1, Math.round(m / 1.35 / 60)); // ~4.9 km/h walking
  if (mins < 60) return `${mins} min walk`;
  const h = Math.floor(mins / 60);
  return `${h}h ${mins % 60}m walk`;
}

export function timeAgo(iso) {
  if (!iso) return "never";
  const then = new Date(iso).getTime();
  const s = Math.max(0, Math.round((Date.now() - then) / 1000));
  if (s < 15) return "just now";
  if (s < 60) return `${s}s ago`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.round(h / 24)}d ago`;
}

export function isStale(iso, thresholdSec = 120) {
  if (!iso) return true;
  return (Date.now() - new Date(iso).getTime()) / 1000 > thresholdSec;
}

// Freshness tiers so people can judge how trustworthy a friend's dot is.
export function freshnessTier(iso) {
  if (!iso) return { key: "gone", label: "no fix yet", color: "#EF4444" };
  const age = (Date.now() - new Date(iso).getTime()) / 1000;
  if (age < 30) return { key: "live", label: "live now", color: "#22C55E" };
  if (age < 120) return { key: "recent", label: `${timeAgo(iso)}`, color: "#EAB308" };
  return { key: "stale", label: `last seen ${timeAgo(iso)}`, color: "#EF4444" };
}

// GPS precision hint from the reported accuracy radius (metres).
export function fmtAccuracy(m) {
  if (m == null || !isFinite(m)) return null;
  if (m < 1000) return `±${Math.round(m)} m`;
  return `±${(m / 1000).toFixed(1)} km`;
}

export function accuracyQuality(m) {
  if (m == null || !isFinite(m)) return null;
  if (m <= 20) return "pinpoint";
  if (m <= 60) return "good";
  if (m <= 150) return "rough";
  return "very rough";
}
